import { render, staticRenderFns } from "./WithdrawalGeneralInstructionsModal.vue?vue&type=template&id=af86c4d4&scoped=true&lang=pug"
import script from "./WithdrawalGeneralInstructionsModal.vue?vue&type=script&lang=js"
export * from "./WithdrawalGeneralInstructionsModal.vue?vue&type=script&lang=js"
import style0 from "./WithdrawalGeneralInstructionsModal.vue?vue&type=style&index=0&id=af86c4d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af86c4d4",
  null
  
)

export default component.exports